/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ProductCharacteristicUnitType = {
    NotSpecified: 'NotSpecified',
    KWH: 'KWH',
    kVArh: 'kVArh',
    KW: 'KW',
    MVAr: 'MVAr',
    MW: 'MW',
    MWh: 'MWh',
    Tonne: 'Tonne',
    Ampere: 'Ampere',
    Stk: 'Stk',
} as const;
export type ProductCharacteristicUnitType = typeof ProductCharacteristicUnitType[keyof typeof ProductCharacteristicUnitType];

